import ScrollTracker from "./scroll_tracker";

export default class ScrollTrackerAnchor
{
  private readonly clickHandler: EventListener;
  private readonly href: string;
  private readonly tracker: ScrollTracker;
  private readonly anchor: HTMLAnchorElement;
  private readonly target: HTMLElement;
  constructor(anchor: HTMLAnchorElement, tracker: ScrollTracker) 
  {
    this.anchor = anchor;
    this.tracker = tracker;

    const href = anchor.getAttribute('href');
    if(typeof href === 'string') {
      this.href = href;
    } else {
      throw new Error("Id not found");
    }

    const target = document.querySelector(this.href);
    if(target instanceof HTMLElement) {
      this.target = target;
    } else {
      throw new Error("Target not found");
    }

    this.clickHandler = this.handleClickEvent.bind(this);

    this.enable();
  }

  enable(): void
  {
    this.anchor.addEventListener('click', this.clickHandler, true);
  }

  handleClickEvent(event: MouseEvent): void
  {
    //deactivate tracker
    this.setActive(true);
    this.target.scrollIntoView();
  }

  toggleActive(): boolean
  {
    const viewportTop = (window.scrollY || window.pageYOffset) - ScrollTracker.OFFSET;
    const viewportBottom = viewportTop + window.innerHeight;

    const targetTop = this.target.offsetTop - ScrollTracker.OFFSET;
    const targetBottom = targetTop + this.target.offsetHeight;

    const isTargetAboveViewport = (
      targetBottom < viewportTop
    )
    const isTargetBelowViewport = (
      viewportBottom < targetTop
    )
    const isTargetOutOfViewport = (
      isTargetAboveViewport
      || isTargetBelowViewport
    );
    const isActive = !isTargetOutOfViewport;
    this.setActive(isActive);
    return isActive;
  }

  setActive(active: boolean): void
  {
    this.anchor.classList.toggle('is-active', active);
  }

  scrollIntoView(): void
  {
    if(
      this.tracker.isHorizontal()
      && this.tracker.currentSideScrollTarget != this
    ) {
      //allow one target at a time
      //is nullified on scrollend event in tracker
      this.tracker.currentSideScrollTarget = this; 
      const anchorOffsetLeft = Math.ceil(this.anchor.offsetLeft);
      const anchorOffsetWidth = Math.ceil(this.anchor.offsetWidth);
      const scrollContainerWidth = Math.ceil(this.tracker.wrapper.offsetWidth);
      const scrollLeftMax = this.tracker.wrapper.scrollWidth - this.tracker.wrapper.offsetWidth;
      const scrollLeftTarget = Math.min(
        scrollLeftMax, //cap maximum scroll
        Math.max( 
          0, //cap minimum scroll
          Math.round(
            anchorOffsetLeft
            + anchorOffsetWidth / 2
            - scrollContainerWidth / 2
          )
        )
      );

      this.tracker.wrapper.scrollTo({
        left: scrollLeftTarget,
        behavior: 'smooth'
      })
    }
  }
}